import { defineAsyncComponent as e } from "vue";
//#endregion
//#region src/lang/index.ts
var t = {
	en: { richtextEditor: {
		words: "Words",
		chars: "Characters",
		heading2: "Headline 2",
		heading3: "Headline 3",
		paragraph: "Body text",
		fullHTML: "Switch to full HTML",
		fullHTMLScriptCode: "Enter full HTML or script code",
		markAffiliate: "Mark as affiliate",
		noRichTextEditor: "The rich text editor is disabled because some tags (e.g. script) aren't supported and may cause data loss if used.",
		useAnyway: "Use rich text editor anyway",
		bold: "Bold",
		italic: "Italic",
		insertLink: "Insert link",
		linkEntities: "Link entities",
		bulletList: "Bullet list",
		numberedList: "Numbered list",
		blockquote: "Blockquote",
		aiAssist: "Improve with AI",
		url: "URL",
		apply: "Apply",
		remove: "Remove",
		linkValidationError: "One or more links in the text block are invalid. Please fix the links before you continue.",
		invalidLinkWithPosition: "Link {n} (\"{text}\") is invalid: \"{href}\"",
		invalidLinkTextFallback: "no link text"
	} },
	de: { richtextEditor: {
		words: "Wörter",
		chars: "Zeichen",
		heading2: "Überschrift 2",
		heading3: "Überschrift 3",
		paragraph: "Fließtext",
		fullHTML: "Auf vollständiges HTML umschalten",
		fullHTMLScriptCode: "Vollständiges HTML oder Script-Code einfügen",
		markAffiliate: "Als Affiliate markieren",
		noRichTextEditor: "Der Rich-Text-Editor wurde nicht aktiviert, da einige Tags (z. B. \"script\") nicht unterstützt werden. Sonst können Daten verloren gehen.",
		useAnyway: "Rich-Text-Editor trotzdem nutzen",
		bold: "Fett",
		italic: "Kursiv",
		insertLink: "Link einfügen",
		linkEntities: "Entitäten verlinken",
		bulletList: "Aufzählung",
		numberedList: "Nummerierte Liste",
		blockquote: "Blockzitat",
		aiAssist: "Mit KI verbessern",
		url: "URL",
		apply: "Übernehmen",
		remove: "Entfernen",
		linkValidationError: "Ein oder mehrere Links im Textblock sind ungültig. Bitte korrigieren Sie die Links, bevor Sie fortfahren.",
		invalidLinkWithPosition: "Link {n} (\"{text}\") ist ungültig: \"{href}\"",
		invalidLinkTextFallback: "ohne Linktext"
	} }
}, n = e(() => import("./richText.editor-BuQJ2jgU.js")), r = {
	routes: [],
	messages: t
};
//#endregion
export { n as RichTextEditor, r as richTextModule };

//# sourceMappingURL=index.es.js.map